module.exports = __webpack_public_path__ + "img/10.305fd2fa.png";